/**
 * Arranca la sincronización y la dispara ante cambios locales, al volver la
 * conexión, al recuperar el foco y periódicamente.
 */
import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/db';
import { bootstrapSession, requestSync } from './engine';
import { useSyncState } from './store';

export function SyncRunner() {
  const { signedIn } = useSyncState();
  const pending = useLiveQuery(() => db.outbox.count(), [], 0);

  useEffect(() => {
    void bootstrapSession().then(() => requestSync(0));
  }, []);

  useEffect(() => {
    if (signedIn && pending > 0) requestSync(1500);
  }, [pending, signedIn]);

  useEffect(() => {
    if (!signedIn) return;
    const onOnline = () => requestSync(0);
    const onVisible = () => document.visibilityState === 'visible' && requestSync(0);
    window.addEventListener('online', onOnline);
    document.addEventListener('visibilitychange', onVisible);
    const id = window.setInterval(() => requestSync(0), 60_000);
    return () => {
      window.removeEventListener('online', onOnline);
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(id);
    };
  }, [signedIn]);

  return null;
}
